import { User } from '@firebase/auth';
import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';
import { withActions, withSelectors } from '../../lib/domains/store/ngxs-ngrx.mapper';
import { withRequestStatus } from '../../lib/domains/store/request-status.feature';
import { UserActions } from './user.action';
import { UserState } from './user.state';

export interface UserStateModel {
  user: User | null;
}

export const UserStore = signalStore(
  { protectedState: false },

  // withState<UserStateModel>({
  //   user: null,
  // }),
  withEntities<UserStateModel>(),
  withRequestStatus(),
  withSelectors({
    user: UserState.user,
    providerDataWithIsVerified: UserState.providerDataWithIsVerified,
  }),
  // Actions
  withActions({
    setUsers: UserActions.SetUser,
    deleteUsers: UserActions.DeleteUsers,
    updateUser: UserActions.UpdateUser,
  }),
  // withComputed((store) => ({
  //   providerDataWithIsVerified: computed(() => {store.user().prov..}),
  // }))
  // withMethods((store) => ({
  //   findLocalUserByName: (name: Signal<string>): Signal<UserStoreModel | undefined> =>
  //     computed(() => {
  //       return store.users().find((x) => (x.userPropForm.partner as PartnerData).name == name()); //             .findIndex(p => p.name == name()) >= 0;
  //     }),
  // })),
  // withHooks({
  //   onInit(
  //     { usersCount },
  //     actions$ = inject(Actions),
  //     destroyRef = inject(DestroyRef),
  //     toastrService = inject(NbToastrService)
  //   ): void {
  //     actions$
  //       .pipe(
  //         ofActionSuccessful(UserActions.SaveUser),
  //         tap({
  //           next: () => {
  //             toastrService.info(`User Saved! - ${usersCount()}`, 'Saved');
  //           },
  //         }),
  //         takeUntilDestroyed(destroyRef)
  //       )
  //       .subscribe();
  //   },
  // })
);
